var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topTips"},[_c('img',{attrs:{"src":_vm.imgUrl + '/APP_RES/home/pinzhiInfo.png',"alt":"大方租车 押金双免"}}),_c('div',{staticClass:"goHome",on:{"click":_vm.goRent}},[_vm._v("开始租车")])])}
var staticRenderFns = []

export { render, staticRenderFns }